export const IM_METHOD_GET = []
export const IM_METHOD_CALL = []
export const IM_METHOD_WATCH = []
export const IM_METHOD_REF = []

export interface $IM_G {}

export interface $IM_C {}

export interface $IM_W {}

export interface $IM_R {}

export interface $IM extends $IM_G, $IM_C, $IM_W, $IM_R {}
